/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

export let translationCatalog = window.django && window.django.catalog ? window.django.catalog : {};

export function djangoGetText(msgid) {
    var value = translationCatalog[msgid];
    if (typeof value == "undefined") {
        return msgid;
    } else {
        return typeof value == "string" ? value : value[0];
    }
}

export function setTranslationCatalog(dynamicTranslationCatalog) {
    translationCatalog = dynamicTranslationCatalog;
}

